<script setup>
import { useQuasar } from 'quasar'
import useRole from '../../../store/role.store'
import RoleUpdate from './Update.vue'
import RoleCreate from './Create.vue'
import Table from '../../shared/Table.vue'
import { callApi } from '../../../utils'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const {
  roleList,
  getRoleList,
  loading,
  pagination,
  filterOptions
} = useRole()

const $q = useQuasar()

const columns = [
  { name: 'name', align: 'left', label: t("roles.name"), field: 'name' },
  { name: 'rules', align: 'left', label: t("roles.rules"), field: 'rules' },
]

function paginate (props) {
  callApi([getRoleList], {
    ...filterOptions.value,
    page: parseInt(props.pagination.page),
    "page-size": parseInt(props.pagination.rowsPerPage)
  }, $q, loading)
}

function showUpdate (_, row) {
  $q.dialog({
    component: RoleUpdate,
    componentProps: { id: row._id }
  })
}

function createRole ( ){
  $q.dialog({
    component: RoleCreate
  })
}

callApi([getRoleList], {
  'page-size': parseInt(pagination.value.rowsPerPage)
}, $q, loading)
console.log("Role list: ", roleList);
</script>

<template lang='pug'>
.role-list
  Table(
    :title='t("menu.roles")'
    :rows='roleList'
    :loading='loading'
    :columns='columns'
    row-key='_id'
    v-model:pagination="pagination"
    @request="paginate"
    @row-click='showUpdate'
  )
    template(v-slot:header='props')
      q-th(v-for="(col, index) in props.cols" :key="col.name")
        div {{ col.label }}

    template(v-slot:body="props")
      q-td(v-for="col in props.cols" :key="col.name")
        div(v-if="col.name==='rules'")
          q-badge.q-pa-xs.q-ma-xs.cursor-pointer(v-for="rule, key in col.value" rounded color='grey-8' :label='key')
            |  - {{ rule.length }}
            q-tooltip.q-pa-none(:style='`padding: 2px;`')
              q-badge(v-for="k in rule" color='grey-8' :style='`margin: 2px;`')
                div
                  div
                    | A: {{ k.actions.join(",") }}
                  div
                    | R: {{ k.resources.length < 2 ? k.resources.join(",") : "..."}}
        div(v-else) 
          | {{ col.value }}
    //- template(v-slot:top-right)
    //-   q-btn.q-ml-sm(
    //-     :class=`$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-4'`
    //-     label='Add role'
    //-     color='primary'
    //-     flat
    //-     @click='createRole'
    //-   )
</template>
